module.exports = "https://s91588.cdn.ngenix.net/home-frontend/_next/static/images/img-49d317fc24772f2988b79db7bdcd1914.png";